import { render } from "./AcademicPost92CheckVerification.vue?vue&type=template&id=1a55d7a6"
import script from "./AcademicPost92CheckVerification.vue?vue&type=script&lang=js"
export * from "./AcademicPost92CheckVerification.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__